import React, { useEffect, useState } from "react";
import ContentItems from "./ContentItems";
import MangeDashboard from "./ManageDashboard";
import { useMediaQuery } from "react-responsive";
import Info from "./ContentMenu/Info";
import EditInformation from "./ContentMenu/Editinformation";
import HistoryOrder from "./ContentMenu/HistoryOrder";
import Referal from "./ContentMenu/referal";
import Comments from "./ContentMenu/Comments";
import Ruls from "./ContentMenu/Ruls";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import AfterLoginNav from "../AfterLoginNav";
import { getUserInfo } from "../../services/profile";
import CardManagement from "./ContentMenu/card-management";
import Channels from "./ContentMenu/Channels";
import Videos from "./ContentMenu/Videos";
import AIChat from "./ContentMenu/AIChat";

export default function AccountInfo({}) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedChannel, setSelectedChannel] = useState(null);
  const activeItem = searchParams.get("active");
  const [logouting, setLogouting] = useState(false);
  const [dataUser, setDataUser] = useState([]);
  const [birth, setBirth] = useState("");
  const navigate = useNavigate();

  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  let query = useQuery();
  let state = query.get("state");

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const [itemActive, setItemActive] = useState(
    state == "ruls"
      ? "ruls"
      : state == "auth"
      ? "auth"
      : isTabletOrMobile
      ? "menu"
      : "info"
  );

  useEffect(() => {
    if (typeof activeItem === "string" && activeItem.length > 0) {
      if (
        activeItem === "auth" ||
        activeItem === "ref" ||
        activeItem === "info" ||
        activeItem === "history" ||
        activeItem === "comm" ||
        activeItem === "ruls" ||
        activeItem === "channels" ||
        activeItem === "videos" ||
        activeItem === "aichat"
      ) {
        setItemActive(activeItem);
      }
      if (activeItem !== "videos") {
        setSelectedChannel(null);
      }
    }
  }, [activeItem]);
  useEffect(() => {
    if (itemActive == "logout") {
      setLogouting(true);
    }
  }, [itemActive]);

  useEffect(() => {
    function fetchData() {
      getUserInfo().then((res) => {
        if (res.status == 200) {
          let data = res.data.data;

          if (data) {
            setDataUser(data);
            setBirth(data.birth_date);
          }
        }
      });
    }
    fetchData();
  }, []);

  return (
    <>
      <MangeDashboard>
        <div className="visible-xs">
          <AfterLoginNav
            title={
              itemActive === "comm"
                ? "پیشنهاد، انتقاد و شکایت"
                : itemActive === "history"
                ? "تاریخچه معاملات"
                : itemActive === "ref"
                ? "دعوت"
                : itemActive === "card-management"
                ? "مدیریت کارت ها"
                : itemActive === "channels"
                ? "فیلم ها"
                : itemActive === "ruls"
                ? "قوانین و مقررات"
                : itemActive === "aichat"
                ? "هوش مصنوعی"
                : "حساب کاربری"
            }
            hasBack={() =>
              itemActive === "menu" ? navigate(-1) : setItemActive("menu")
            }
          />
          {itemActive == "menu" && (
            <ContentItems
              name={
                dataUser.first_name + " " + dataUser.last_name
                  ? dataUser.first_name + " " + dataUser.last_name
                  : "در حال بارگیری"
              }
              date={birth}
              isAuth={true}
              setItemActive={setItemActive}
              state={state}
            />
          )}
          {itemActive == "card-management" && <CardManagement />}

          {itemActive == "info" && <Info />}

          {itemActive == "auth" && <EditInformation />}

          {itemActive == "history" && <HistoryOrder />}

          {itemActive == "ref" && <Referal />}

          {itemActive == "comm" && <Comments />}

          {itemActive == "ruls" && <Ruls />}

          {itemActive == "aichat" && <AIChat />}

          {itemActive == "channels" && (
            <Channels
              onChannelSelect={(channel) => {
                setSelectedChannel(channel);
                setItemActive("videos");
              }}
            />
          )}

          {itemActive == "videos" && (
            <Videos
              videoChannel={selectedChannel}
              handleBack={() => {
                setSelectedChannel(null);
                setItemActive("channels");
              }}
            />
          )}
        </div>
        <div className="hidden-xs">
          <div className="container pt-account">
            <div className="row justify-content-center h-100 align-items-center">
              <div className="col-12 col-md-10">
                <div className="d-flex">
                  <div className="menu2022">
                    <ContentItems
                      name={
                        dataUser.first_name + " " + dataUser.last_name
                          ? dataUser.first_name + " " + dataUser.last_name
                          : "در حال بارگیری"
                      }
                      date={birth}
                      isAuth={true}
                      setItemActive={setItemActive}
                      state={state}
                    />
                  </div>

                  <div className="responseItems2022">
                    {itemActive == "card-management" && <CardManagement />}
                    {itemActive == "info" && <Info />}
                    {itemActive == "auth" && <EditInformation />}
                    {itemActive == "history" && <HistoryOrder />}
                    {itemActive == "ref" && <Referal />}
                    {itemActive == "comm" && <Comments />}
                    {itemActive == "ruls" && <Ruls />}
                    {itemActive == "aichat" && <AIChat />}
                    {itemActive == "channels" && (
                      <Channels
                        onChannelSelect={(channel) => {
                          setSelectedChannel(channel);
                          setItemActive("videos");
                        }}
                      />
                    )}

                    {itemActive == "videos" && (
                      <Videos
                        videoChannel={selectedChannel}
                        handleBack={() => {
                          setSelectedChannel(null);
                          setItemActive("channels");
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MangeDashboard>
    </>
  );
}
